export default {
  metaTitle: 'Manage Main Account',
  pageTitle: 'Manage Main Account',
  columns1: 'Login ID',
  columns2: 'Login Name',
  columns3: 'Phone',
  columns4: 'Create Time',
  columns5: 'Last Login Time',
  columns6: 'Status',
  columns7: 'Operation',
  columns8: 'Reset Password',
  locking1: 'Locked',
  locking2: '解锁',
  passwordTips1: '两次密码不一致',
  passwordTips12: '请输入正确的密码',
  error1: '请输入密码',
  error2: '请输入重置密码',
  tips1: '您将',
  tips2: '账号',
  resetPassword: 'Reset password',
  resetAccount: 'Reset the password for store named "{0}"',
  placeholder1: 'Enter password',
  tips3: 'Accepts letters, numbers, underscores, English periods, and # symbols.',
  placeholder2: ' Confirm password',
  statusType1: 'Normal',
  statusType2: 'Locked',

  // EditorAccount
  noAccountTips: '请先填写手机号/邮箱',
  phoneLabel: 'Phone No.',
  emailLabel: 'Email Address',
  accountPlaceholder: 'New phone number/email.',
  codePlaceholder: 'Enter the verification code',
  areaPlaceholder: '区号',
  regionPlaceholder: '国家',
  checkContentLabel: 'Verification item',
  checkTypeLabel: '验证方式',
  title1Label: 'Change to (Leave blank if no change)',
  title2Lable: 'Modify Content',
  okBtnText: 'Submit',
  cancelBtnText: 'Cancel',
  modalTitle: 'Modify Main Account({0})',
  sendCodeText: 'Send Code',
  editorBtn: 'Edit',
  errorNewAccountTips: '请填写正确的{0}',
  noCheckContent: '请验证变更内容',
  noCheckType: '请先验证校验方式',
  noSelectContactError: '请选择校验手机号/邮箱',
  noSelectNewTypeError: '请选择变更内容',
  noCodeError: '请填写验证码',
  curRegionNameLabel: 'Region of Seller：',
  success: 'success'
}
